import { Box } from '#core/components';

type Props = {
  children: React.ReactNode;
};

export const ListBoxEmpty = ({ children }: Props) => {
  return <Box p={2}>{children}</Box>;
};
